// extracted by extract-css-chunks-webpack-plugin
module.exports = {"aligned":"_3C5qQV","grid":"gLOPqM","centered-section-spacing":"HfTzQD","grid-odd":"_3-q0JM","newsArticlesContainer":"_2z-Q64","blackLink":"_1NEzUH"};